<div class="card tile-shadow h-100">
  <div class="card-header bg-white header">
    <div class="row">
      <div class="col-10">
        <h3 class="fw-bold">Quick Reports</h3>
        <small data-testid="paydateLabel"
          >{{ report.PayDate | date: 'MM/dd/yyyy'
          }}<span *ngIf="canAccessGeneralLedger" data-testid="frequency"
            >- {{ report.Frequency }}</span
          ></small
        >
      </div>
      <div class="col-2 text-end">
        <img src="assets/icons/reports-black.svg" />
      </div>
    </div>
  </div>
  <div class="list-group list-group-flush h-75">
    <div
      class="list-group-item row-height d-flex flex-row justify-content-between"
      *ngIf="!canAccessGeneralLedger">
      <span class="fw-bold mt-auto mb-auto">Frequency</span
      ><span class="mt-auto mb-auto"> {{ report.Frequency }}</span>
    </div>
    <div
      class="list-group-item d-flex justify-content-between row-height align-items-center"
      *ngFor="let report of report.Reports">
      <span class="mt-auto mb-auto fw-bold">{{ report.Name }}</span>
      <button class="btn btn-tertiary" (click)="downloadReport(report)">
        Download <i class="fas fa-download"></i>
      </button>
    </div>
    <div
      class="list-group-item d-flex justify-content-between row-height align-items-center"
      *ngIf="report.Reports.length === 0">
      <span>No reports available.</span>
    </div>
    <div
      class="list-group-item row-height d-flex justify-content-between align-items-center"
      *ngIf="canAccessGeneralLedger">
      <span class="fw-bold mt-auto mb-auto">General Ledger</span
      ><span class="mt-auto mb-auto"> </span>
      <button class="btn btn-tertiary" (click)="glClicked()">Start Export</button>
    </div>
  </div>
</div>
